import {ContactModel} from './contact.model';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomerModel {
    public id: number;
    public depot: number;
    public cod: string;
    public name: string;
    public add1: string;
    public add2: string;
    public add3: string;
    public add4: string;
    public tender: string;
    public pricelist: string;
    public sites: [];
    public contacts: ContactModel[];
    public hireDisc: number;
    public saleDisc: number;
    public accountType: string;
    public suspended: string;
    public badDebt: string;
    public _id: string;

    [x: string]: any;
}
